export default __webpack_public_path__ + "static/media/resources-icon-yellow.a323b3df.svg";